import { ActionType, actionTypes, UserState } from './user.type';

// Define initial state
export const initialState: UserState = {
  user: null,
  isLoading: false,
  isLoggingOut: false,
  isAccountSwitchingInProgress: false,
  affiliationsByCompany: undefined,
  currentTeamId: null,
  currentContractId: null,
  currentCompany: null,
  currentContract: null,
  roleType: null,
  subRoleType: null,
  showAccountSwitcher: false,
  otpData: {
    showOTPModal: false,
    methodIDForOTP: '',
    emailForOTP: '',
    mfaType: '',
  },
  isTOTPSetupInProgress: false,
  isUserProfileReady: false,
  hasNoAffiliations: false,
  hasAffiliationsError: false,
};

// Reducer function
export function userReducer(state: UserState, action: ActionType): UserState {
  switch (action.type) {
    case actionTypes.SET_USER_PROFILE_DATA:
      return {
        ...state,
        user: action.payload.user,
        roleType: action.payload.roleType,
        subRoleType: action.payload.subRoleType,
        affiliationsByCompany: action.payload.affiliationsByCompany,
        currentCompany: action.payload.currentCompany,
        currentContract: action.payload.currentContract,
        currentContractId: action.payload.currentContractId,
        showAccountSwitcher: action.payload.showAccountSwitcher,
        canSkip2FA: action.payload.canSkip2FA,
        is2FAVerified: action.payload.is2FAVerified,
        isUserProfileReady: action.payload.isUserProfileReady,
      };
    case actionTypes.SET_USER:
      return { ...state, user: action.payload };
    case actionTypes.SET_LOADING:
      return { ...state, isLoading: action.payload };
    case actionTypes.SET_LOGGING_OUT:
      return { ...state, isLoggingOut: action.payload };
    case actionTypes.SET_ACCOUNT_SWITCHING:
      return { ...state, isAccountSwitchingInProgress: action.payload };
    case actionTypes.SET_AFFILIATIONS:
      return { ...state, affiliationsByCompany: action.payload };
    case actionTypes.SET_CURRENT_TEAM_ID:
      return { ...state, currentTeamId: action.payload };
    case actionTypes.SET_CURRENT_CONTRACT_ID:
      return { ...state, currentContractId: action.payload };
    case actionTypes.SET_CURRENT_COMPANY:
      return { ...state, currentCompany: action.payload };
    case actionTypes.SET_CURRENT_CONTRACT:
      return { ...state, currentContract: action.payload };
    case actionTypes.SET_ROLE_TYPE:
      return { ...state, roleType: action.payload };
    case actionTypes.SET_SUB_ROLE_TYPE:
      return { ...state, subRoleType: action.payload };
    case actionTypes.SET_SHOW_ACCOUNT_SWITCHER:
      return { ...state, showAccountSwitcher: action.payload };
    case actionTypes.SET_OTP_DATA:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          ...action.payload,
        },
      };
    case actionTypes.RESET_STATE:
      return initialState;
    case actionTypes.SET_OTP_DATA_AND_LOADING:
      return {
        ...state,
        otpData: {
          ...state.otpData,
          ...action.payload.otpData,
        },
        isLoading: action.payload.isLoading,
      };
    case actionTypes.SET_TOTP_SETUP_STATUS:
      return {
        ...state,
        isTOTPSetupInProgress: action.payload,
      };
    case actionTypes.SET_LOADING_AND_LOGGING_OUT:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoggingOut: action.payload.isLoggingOut,
      };
    case actionTypes.SET_IS_2FA_VERIFIED:
      return { ...state, is2FAVerified: action.payload };
    case actionTypes.SET_USER_PROFILE_READY:
      return { ...state, isUserProfileReady: action.payload };
    case actionTypes.SET_HAS_NO_AFFILIATIONS:
      return { ...state, hasNoAffiliations: action.payload };
    case actionTypes.SET_HAS_AFFILIATIONS_ERROR:
      return { ...state, hasAffiliationsError: action.payload };

    default:
      return state;
  }
}
